var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddWatermark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 54C21.7909 54 20 52.2091 20 50V46.603C20.0018 44.5397 21.3533 42.7072 23.3569 42.0571L31.8262 39.307C32.2363 39.1739 32.5137 38.7949 32.5137 38.3676V37.8505C32.5137 37.5619 32.3862 37.2878 32.1649 37.0999C28.2145 33.7479 27.1192 28.0299 29.836 23.441C31.7408 20.2238 35.1883 18.1857 38.9702 18.0119L39.5009 18L39.9823 18.0097C45.9247 18.2547 50.658 23.0335 50.6603 28.8848C50.6615 32.0662 49.2406 35.0511 46.8338 37.098C46.6129 37.2859 46.4859 37.5597 46.4859 37.8479V38.3676C46.4859 38.7948 46.7632 39.1738 47.1733 39.3069L55.642 42.0569C57.6482 42.7078 59 44.5428 59 46.6076V50C59 52.2091 57.2091 54 55 54H24Z",
    stroke: "#8170FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61H59",
    stroke: "#FD5B01",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWatermark);
export default __webpack_public_path__ + "static/media/add-watermark.e0de4fa4.svg";
export { ForwardRef as ReactComponent };